var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal_login","size":"md","title":"Acceso / Login","hide-header":"","ok-only":"","content-class":"shadow","button-size":"sm","centered":"","ok-title":"Cancelar","ok-variant":"outline-secondary"}},[_c('login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }